function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 12L18.667 16M13 12H22H13ZM22 12L18.667 8L22 12Z",
  stroke: "#4A4D58",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 7.00022V5.17422C14 4.89759 13.9426 4.62398 13.8314 4.37066C13.7203 4.11735 13.5578 3.88986 13.3542 3.70255C13.1507 3.51524 12.9104 3.3722 12.6488 3.28247C12.3871 3.19273 12.1097 3.15826 11.834 3.18122L3.834 3.84722C3.33405 3.88886 2.86801 4.11687 2.5283 4.48603C2.18859 4.85519 2.00002 5.33854 2 5.84022V18.1602C2.00002 18.6619 2.18859 19.1452 2.5283 19.5144C2.86801 19.8836 3.33405 20.1116 3.834 20.1532L11.834 20.8202C12.1098 20.8432 12.3873 20.8087 12.649 20.7189C12.9107 20.6291 13.151 20.486 13.3546 20.2985C13.5582 20.1111 13.7206 19.8835 13.8317 19.6301C13.9428 19.3767 14.0001 19.1029 14 18.8262V17.0002",
  stroke: "#4A4D58",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.619fa1a2.svg";
export { ForwardRef as ReactComponent };